import { BaseService } from "mrb/core";

class BetaChannelService extends BaseService {}

export default BetaChannelService;
